import styled from 'styled-components'
import { Card } from '@mui/material'
import themeColors from '@layers-frontend/commons/styles/themeColors'
import { surfaces } from '../../theme'

export const CarouselOuterWrapper = styled.div`
  position: relative;
  width: 100%;
  margin: 40px auto 20px auto;
  display: flex;
  align-items: center;
`

export const CarouselContainer = styled.div`
  width: 100%;
  padding: 0 100px;
  margin: 0 40px;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  @media (max-width: 1000px) {
    padding: 0 60px;
  }
  @media (max-width: 600px) {
    padding: 0 44px;
  }
`

export const CarouselTrack = styled.div`
  display: flex;
  transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  gap: 40px;
  width: 100%;
`

export const BlogCard = styled(Card)`
  width: 100%;
  max-width: 320px;
  background: ${themeColors.blueColor};
  border: 1px solid ${themeColors.mintBorder};
  color: ${themeColors.whiteColor};
  position: relative;
  overflow: hidden;
  margin: 0;
  padding: 0;
  flex: 0 0 auto;
  border-radius: 0;
  transition: box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1), border-color 0.3s cubic-bezier(0.4, 0, 0.2, 1), background 0.3s cubic-bezier(0.4, 0, 0.2, 1),
    color 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  /* The doubled class beats the elevation shadow of MUI's Paper. */
  && {
    box-shadow: ${surfaces.floatingPanelShadow};
  }

  &:hover {
    border-color: ${themeColors.mintColor};
    background: ${themeColors.blueColor};
    color: ${themeColors.whiteColor};
    .MuiCard-root {
      background: transparent !important;
      color: ${themeColors.whiteColor} !important;
    }
    h3,
    p,
    div,
    a {
      color: ${themeColors.whiteColor} !important;
      text-shadow: none !important;
    }
  }

  .MuiCard-root {
    width: 100% !important;
    max-width: 320px !important;
    background: transparent !important;
    color: ${themeColors.whiteColor} !important;
  }

  @media (max-width: 1000px) {
    max-width: 280px;
    .MuiCard-root {
      max-width: 280px !important;
    }
  }

  @media (max-width: 600px) {
    max-width: 100%;
    .MuiCard-root {
      max-width: 100% !important;
    }
  }
`

export const CardImage = styled.div`
  width: 100%;
  aspect-ratio: 16 / 9;
  height: 220px;
  position: relative;
  overflow: hidden;
  border-radius: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
  }

  &:hover img {
    transform: scale(1.04);
  }
`

export const Overlay = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 32px 24px 20px 24px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 40%, rgba(0, 0, 0, 0.6) 100%);
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  min-height: 120px;
  z-index: 2;
  pointer-events: none;
  border-radius: 0;
`

export const OverlayContent = styled.div`
  pointer-events: auto;
`
